/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const changeOrConfigurationErrorEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type ChangeOrConfigurationErrorEnumsPotentialConsequenceOptionEnumKey =
    (typeof changeOrConfigurationErrorEnumsPotentialConsequenceOptionEnum)[keyof typeof changeOrConfigurationErrorEnumsPotentialConsequenceOptionEnum];

export type ChangeOrConfigurationErrorEnumsPotentialConsequenceOption =
    ChangeOrConfigurationErrorEnumsPotentialConsequenceOptionEnumKey;
